import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, watch } from '@nuxtjs/composition-api';

interface Props {
    theme?: 'light' | 'dark',
    disabled?: boolean,
    type?: 'outline' | 'tonal' | 'icon',
    modes?: any[],
    value?: Props['modes'][number],
    nextMode?: (currentValue: any, modes: any[]) => any,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModeButton',
  props: {
    theme: null,
    disabled: { type: Boolean },
    type: { default: 'tonal' },
    modes: { default: () => [true, false] },
    value: null,
    nextMode: { type: Function, default: (currentValue: any, modes: any[]) => {
        const currentIndex = modes.indexOf(currentValue);
        return modes[(currentIndex + 1) % modes.length];
    } }
  },
  emits: ["change", "input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'change', value: Props['value']): void,
    (e: 'input', value: Props['value']): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { theme?: 'light' | 'dark', disabled?: boolean, type: 'outline' | 'tonal' | 'icon', modes: any[], value?: Props['modes'][number], nextMode: (currentValue: any, modes: any[]) => any };





const {
    theme,
    disabled,
    type,
    nextMode,
    value,
} = toRefs(props);

const internalValue = ref(props.value);

watch(value, (newValue) => {
    internalValue.value = newValue;
}, { immediate: true });

const switchMode = () => {
    internalValue.value = nextMode.value(internalValue.value, props.modes);
    emit('input', internalValue.value);
    emit('change', internalValue.value);
};


return { __sfc: true,emit, props, theme, disabled, type, nextMode, value, internalValue, switchMode }
}

})